// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroSchoolView-module--wrapper--UGbqU","textContainer":"HeroSchoolView-module--textContainer--17IQ6","img":"HeroSchoolView-module--img--GIjxV"};